export default __webpack_public_path__ + "static/media/v3Our-services-MICE-photo.ea080784.jpg";